const analyticsEndpoint = '/api/cms/api/analytics'

const getAnalyticsBySnomed = async (snomed: string) => {
    if (!snomed) throw new Error('No SNOMED code provided')

    const query = new URLSearchParams({
        populate: '*',
        'filters[snomed][$eq]': snomed
    })

    return await fetch(`${analyticsEndpoint}?${query.toString()}`)
}

// NOTE: retrieves the medical term meaning and bracket insights for a SNOMED code.
// Query kept identical to the former health-api controller to avoid behavioural drift.
const getAnalyticInsights = async (snomed: string) => {
    if (!snomed) throw new Error('No SNOMED code provided to retrieve insights')

    const query = new URLSearchParams({
        'populate[0]': 'cover',
        'populate[1]': 'videos',
        'populate[2]': 'brackets.label',
        'filters[snomed]': snomed
    })

    return await fetch(`${analyticsEndpoint}?${query.toString()}`)
}


export {
    getAnalyticsBySnomed,
    getAnalyticInsights,
}
